import React from 'react';
import { TextField } from '@material-ui/core';
import './style.scss';

const defaultInputStyle = {
  backgroundColor: 'white',
  boxSizing: 'border-box',
  height: 40,
  fontSize: 16,
  paddingRight: '2px !important',
  width: '100%',
};

export function EeInput(props: any) {
  const {
    type,
    register,
    name,
    inputStyle = defaultInputStyle,
    disabled,
    inputProps,
    defaultValue,
    onChange,
  } = props;

  return (
    <TextField
      InputProps={{
        style: inputStyle,
      }}
      inputRef={register}
      inputProps={inputProps}
      variant="outlined"
      onChange={onChange}
      disabled={disabled}
      name={name}
      type={type}
      defaultValue={defaultValue}
    />
  );
}
